import React from 'react';

const Parameters = () => (
  <>
    <div>Parameters</div>
  </>
);

export default Parameters;
